import { CanDeactivateFn } from '@angular/router';
import { DocumentUploadComponent } from '../components/document-upload/document-upload.component';
import { inject } from '@angular/core';
import { WorkflowService } from '../services/workflow.service';

export const documentUploadGuard: CanDeactivateFn<DocumentUploadComponent> =
  (component) => {    
    const currentRoute = inject(WorkflowService).currentRoute;
    if (currentRoute === 'document-upload' && !component.isComplete$()) {      
      component.displayWarningPopup();
      return false;
    }
    return true;
  };
